<template lang="pug">
	div
		h3 Для перехода на следующий шаг:
		p.mb-3 Введите информацию о Вашей организации, чтобы получить документы на оплату:

		b-alert(:show='alert.error.hideCountDown' fade variant='danger' @dismissed='alert.error.hideCountDown=0' @dismiss-count-down='countDownChanged($event, "error")')
			h4.alert-heading Error!
			p {{ alert.error.message }}

		b-alert.mb-3(:show='alert.success.hideCountDown' fade variant='success' @dismissed='alert.success.hideCountDown=0' @dismiss-count-down='countDownChanged($event, "success")')
			p {{ alert.success.message }} Вы будете перенаправлены на следующий этап через {{ alert.success.hideCountDown }}
		.mb-3
			b-form(inline @submit='onSubmit($event)' v-if="!alert.success.hideCountDown" style="margin:-10px;")
				div(style="margin:10px; flex:1 0 auto;")
					b-input-group.mb-0
						b-form-file(v-model="form.company_file" name="company_file" placeholder='Реквизиты организации' drop-placeholder='Drop file here...' style="width:auto;" :state="isSomeFieldTrue" :disabled="checkDisabled('company_file')")
				div(style="margin:10px; flex:1 0 auto;")
					b-input-group.mb-0
						b-form-input.form-control(v-model="form.company_tax" type="number" name="company_tax" placeholder='ИНН организации' :state="isSomeFieldTrue" :disabled="checkDisabled('company_tax')")
				div(style="margin:10px; flex:1 0 auto; justify-content: flex-start;")
					b-form-group.mb-0
						b-form-checkbox(name="is_individual" v-model="form.is_individual" :state="isSomeFieldTrue" :disabled="checkDisabled('is_individual')") Физическое лицо

				div(style="margin:10px; flex:1 0 auto;")
					b-button(variant='primary' type="submit") Отправить

				b-form-invalid-feedback(:state="isSomeFieldTrue" style="margin:10px;") Нужно заполнить один из пунктов

</template>

<script>
	import {mapActions, mapState} from 'vuex';


	export default {
		name: 't-option',
		data: () => ({
			alert: {
				success: { hideSecs:5, hideCountDown:0, message: 'Форма успешно отправлена!' },
				error: { hideSecs: 5, hideCountDown: 0, message: 'Произошла ошибка!' }
			},
			form: {
				company_file: null,
				company_tax: '',
				is_individual: false,
			}
		}),
		computed: {
			...mapState(['myParticipant', 'account']),

			isSomeFieldTrue(){ return Object.values(this.form).some(item=>item && item !== ''); },
			getPPID(){ return parseInt(this.$router.history.current.params.id) || null; },
			formData(){
				const data = new FormData();
				for ( let prop in this.form ) { // TODO: try Array.prototype.reduce
					if (this.form[prop]){ data.append(prop, this.form[prop]) }
				}
				return data;
			},
		},
		methods: {
			...mapActions(['getMyParticipant',"increaseStageMyParticipant", "patchAccount"]),

			checkDisabled(fieldName){
				const someTrue = Object.values(this.form).filter( item => !item || item === '' );
				return this.isSomeFieldTrue ? someTrue.includes(this.form[fieldName]) : false;
			},
			countDownChanged(hideCountDown, event) {
				this.alert[event].hideCountDown = hideCountDown;
			},
			onSubmit(e) {
				e.preventDefault();
				if (!this.isSomeFieldTrue) return false;
				this.$store.dispatch('patchAccount', this.formData).then(this.successFormHandler);
			},
			async successFormHandler(){
				await this.$store.dispatch('increaseStageMyParticipant',{id:this.getPPID});
				this.showAlert(this.alert.success.message, 'success');
				setTimeout(()=>{
					this.$store.dispatch('getMyParticipant', {id:this.getPPID})
				}, 5000);
			},
			errorFormHandler(error) { return this.showAlert(error.non_field_errors ? error.non_field_errors[0] : '', 'error') } ,
			showAlert(message, event) {
				this.alert[event].hideCountDown = this.alert[event].hideSecs;
				this.alert[event].message = message ? message : this.alert[event].message;
			},
		},
	}
</script>

<style lang="scss">
	.form-inline label {
		justify-content: flex-start;
	}
</style>
